
export { default as InstituteLoboCreate } from './InstituteLoboCreate';
export { default as EditinstituteLobo } from './EditinstituteLobo';
export { default as InstituteLoboList } from './InstituteLoboList';
export { default as Header } from '../Header';
export { default as AdminNavbar } from '../AdminNavbar';
export { default as Adminmain } from '../Adminmain';
